import { useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { X } from "lucide-react";

const GallerySection = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    {
      src: "https://images.pexels.com/photos/1583244/pexels-photo-1583244.jpeg?w=600&q=80",
      alt: "Spiritual Temple Setting",
      title: "Sacred Space",
    },
    {
      src: "https://images.unsplash.com/photo-1729335511883-29eade10006b?w=600&q=80",
      alt: "Vedic Consultation",
      title: "Astrological Charts",
    },
    {
      src: "https://images.unsplash.com/photo-1717677977177-c9577c04cf27?w=600&q=80",
      alt: "Spiritual Meditation",
      title: "Meditation Sessions",
    },
    {
      src: "https://images.pexels.com/photos/6931870/pexels-photo-6931870.jpeg?w=600&q=80",
      alt: "Vedic Rituals",
      title: "Zodiac Wheel",
    },
  ];

  return (
    <section id="gallery" className="py-20 lg:py-32 bg-secondary/30 relative">
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-primary font-medium mb-2">Gallery</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Consultation <span className="text-gradient-gold">Gallery</span>
          </h2>
          <div className="section-divider mx-auto" />
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {galleryImages.map((image, index) => (
            <div
              key={index}
              className="relative aspect-square rounded-xl overflow-hidden cursor-pointer group"
              onClick={() => setSelectedImage(image)}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-background/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="font-display text-lg font-semibold text-foreground">
                    {image.title}
                  </p>
                </div>
              </div>
              {/* Border Glow */}
              <div className="absolute inset-0 rounded-xl border-2 border-transparent group-hover:border-primary/50 transition-colors duration-300" />
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Dialog */}
      <Dialog open={!!selectedImage} onOpenChange={() => setSelectedImage(null)}>
        <DialogContent className="max-w-4xl bg-card border-border p-2">
          {selectedImage && (
            <div className="relative">
              <img
                src={selectedImage.src}
                alt={selectedImage.alt}
                className="w-full h-auto rounded-lg"
              />
              <div className="absolute bottom-4 left-4 bg-background/80 backdrop-blur-sm rounded-lg px-4 py-2">
                <p className="font-display text-lg font-semibold text-foreground">
                  {selectedImage.title}
                </p>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default GallerySection;
